import React, { useEffect, useState, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import '../../index.css';
import botImage from '../../../../../../assets/images/bot_users.svg';
import { getCompanyUsersBotsTotal } from '../../../../../../store/actions/reports';

const OrgTotalBotsUser = (props) => {
  const {
    getCompanyUsersBotsTotal,
    match,
    user,
    usersBots,
    searchTerm,
  } = props;
  const { orgId } = match.params;
  const token = user.dashboard_token;

  const [currentList, setCurrentList] = useState([]);

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    getCompanyUsersBotsTotal(orgId, token);
  }, []);

  /**
   * Called for fetch new data for this component when the current data change
   */
  useEffect(() => {
    setCurrentList(usersBots);
  }, [usersBots]);

  /**
   * Called when the searchTerm change, for update the filtered list of elements
   */
  useEffect(() => {
    updateCurrentList();
  }, [searchTerm]);

  /**
   * Update the current list used for displaying the cards
   */
  const updateCurrentList = () => {
    if (searchTerm === '') {
      setCurrentList(usersBots);
    } else {
      formatCustomCurrentList();
    }
  };

  /**
   * Format the current list for a custom filtered by the search term
   */
  const formatCustomCurrentList = () => {
    const filterList = _.filter(currentList, (list) => {
      const hasUserName =
        list.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
      const hasBotName = _.compact(
        _.map(currentList, (list) => {
          const botFind = _.filter(
            list.bots,
            (bot) =>
              bot.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
          );
          if (botFind.length > 0) {
            return botFind;
          }
        })
      );

      if (hasUserName || hasBotName.length > 0) {
        return list;
      }
    });

    setCurrentList(filterList);
  };

  /**
   * Render user per bots container and cards
   */
  const renderUserBotsContainers = () => {
    return _.map(currentList, (user) => {
      return (
        <div key={user._id} className="container-bots-users-relatorios">
          <div className="header-bots-users">
            <img src={user.profilePhoto} />
            <p>{user.name}</p>
          </div>
          {renderCardBotsInfo(user.bots)}
        </div>
      );
    });
  };

  /**
   * Render the card bots information
   * @param {Object[]} bots
   */
  const renderCardBotsInfo = (bots) => {
    return _.map(bots, (bot, index) => {
      return (
        <div
          key={bot.name}
          className={`body-bots-users lek-${bot.name}`}
          style={{ backgroundColor: `${index % 2 === 0 ? '' : '#E9EBEE'}` }}
        >
          <img src={botImage} />
          <p>{bot.name}</p>
        </div>
      );
    });
  };

  return <Fragment>{renderUserBotsContainers()}</Fragment>;
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    usersBots: state.reports.orgUsersBotsTotal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCompanyUsersBotsTotal }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrgTotalBotsUser)
);
